// extracted by mini-css-extract-plugin
module.exports = {"metaIcon":"SEOHomeText_metaIcon__6fk2n","block":"SEOHomeText_block__JnhjR","inner":"SEOHomeText_inner__TbFq7"};